import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CrossSellModal } from './CrossSellModal';
import { SkipButton } from './SkipButton';
import { getBumps, saveBumps, wantsBono23, CART_URLS } from '../../utils/checkoutUrls';
export function Bonus1Section() {
  const [selected, setSelected] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleToggle = () => {
    const newVal = !selected;
    setSelected(newVal);
    const bumps = getBumps();
    bumps.upsellBump1 = newVal;
    saveBumps(bumps);
  };
  const handleBuy = () => {
    if (wantsBono23()) {
      window.open(CART_URLS.allBonuses, '_blank');
    } else {
      setShowModal(true);
    }
  };
  return <div id="bonos" className="flex flex-col h-full" data-id="element-234">
      <div className="flex-1 flex flex-col" data-id="element-235">
        <motion.div className="bg-white rounded-3xl shadow-soft-xl border border-beige relative overflow-hidden flex-1 flex flex-col" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-236">
          <div className="bg-gradient-to-r from-terracotta to-gold-soft text-white text-center py-3 font-semibold tracking-widest uppercase text-sm" data-id="element-237">
            Oferta Especial
          </div>

          <div className="absolute -top-24 -right-24 w-64 h-64 bg-sage-50 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-238"></div>

          <div className="relative z-10 p-6 md:p-8 flex-1 flex flex-col" data-id="element-239">
            <div className="text-center mb-4" data-id="element-240">
              <span className="inline-block px-4 py-1.5 rounded-full bg-sage/10 text-sage font-semibold text-sm tracking-wide mb-3" data-id="element-241">
                BONO 1
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-text-dark" data-id="element-242">
                25 Recetas Anti-Inflamatorias
              </h2>
            </div>

            <div className="mb-5 flex justify-center" data-id="element-243">
              <img src="https://cdn.magicpatterns.com/uploads/vkUhR5VSZbJJ7XEzozQ6Uw/ChatGPT_Image_11_mar_2026,_11_50_25_p.m..png" alt="25 Recetas Anti-Inflamatorias" className="w-full h-64 rounded-xl shadow-md object-cover" data-id="element-244" />
            </div>

            <p className="text-text-medium text-center text-sm mb-4 max-w-md mx-auto" data-id="element-245">
              Recetario práctico con comidas simples y deliciosas que
              complementan tu plan de 14 días.
            </p>

            <div className="flex flex-col gap-2.5 mb-5 max-w-xs mx-auto" data-id="element-246">
              {['Fáciles de preparar', 'Ingredientes simples', 'Nutritivas'].map((item, idx) => <span key={idx} className="flex items-center gap-2 text-sm font-medium text-text-dark bg-sage-50 px-4 py-2.5 rounded-xl" data-id="element-247">
                  <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0" data-id="element-248" />
                  {item}
                </span>)}
            </div>

            <div className="flex flex-col items-center text-center max-w-md mx-auto mt-auto" data-id="element-249">
              <div className="mb-1 text-sm" data-id="element-250">
                <span className="text-text-medium" data-id="element-251">Antes: </span>
                <span className="line-through text-text-light font-medium" data-id="element-252">
                  $49
                </span>
              </div>

              <span className="text-5xl font-heading font-bold text-terracotta mb-1" data-id="element-253">
                Hoy solo $9
              </span>

              <div onClick={handleToggle} className={`w-full flex items-center justify-center gap-3 py-4 px-6 rounded-xl cursor-pointer transition-all duration-300 border-2 mt-4 ${selected ? 'bg-sage text-white border-sage shadow-lg' : 'bg-white text-text-dark border-terracotta hover:bg-terracotta/5'}`} data-id="element-254">
                <div className={`w-6 h-6 rounded-md flex-shrink-0 flex items-center justify-center border-2 transition-colors ${selected ? 'bg-white border-white' : 'border-terracotta bg-white'}`} data-id="element-255">
                  {selected && <CheckIcon className="w-4 h-4 text-sage" strokeWidth={3} data-id="element-256" />}
                </div>
                <span className="font-semibold text-lg" data-id="element-257">
                  {selected ? '¡Añadido! ✓' : 'Sí, quiero este bono por $9'}
                </span>
              </div>

              <CTAButton text="Comprar ahora" variant="primary" className={`w-full mt-3 ${!selected ? 'opacity-40 pointer-events-none' : ''}`} onClick={handleBuy} data-id="element-258" />
            </div>
          </div>
        </motion.div>
      </div>

      <CrossSellModal isOpen={showModal} emoji="🎁" title="¡Espera! ¿Quieres agregar la Lista de Compras + 15 Bebidas por solo $9 más?" description="Obtén los 3 bonos completos y aprovecha al máximo tu plan de 14 días." declineText="No gracias, solo quiero este bono" onAccept={() => {
      setShowModal(false);
      window.open(CART_URLS.allBonuses, '_blank');
    }} onDecline={() => {
      setShowModal(false);
      window.open(CART_URLS.bono1Only, '_blank');
    }} data-id="element-259" />
    </div>;
}